import { DownloadFile } from '@/types/components';

export const downloadFile = (file: DownloadFile) => {
  const link = Object.assign(document.createElement('a'), {
    href: file.url,
    download: file.fileName ?? '',
    style: 'display:none',
  });

  try {
    document.body.appendChild(link);
    window.__isDownloading = true;
    setTimeout(() => {
      window.__isDownloading = false;
    }, 0);
    link.click();
  } catch (e) {
    console.error(e);
  } finally {
    link.remove();
  }
};

export const downloadBlobFile = (data: BlobPart, fileName: string, mimeType = 'text/plain') => {
  const url = URL.createObjectURL(new Blob([data], { type: mimeType }));
  downloadFile({ url, fileName });
  setTimeout(() => URL.revokeObjectURL(url), 100);
};
